import React, { useEffect, useState } from 'react'
import { HitApi } from '../../Api/ApiHit'
import { searchBill } from '../../constant/Constant'
import AutoBillingPage from './AutoBillingPage';

function EditStafffBill() {
    const url = window.location.pathname;
    const urlId = url.split('/')[3];
    const [data, setData] = useState(null);
    useEffect(() => {
        if (urlId) {
            getAutoBills(urlId)
        }
    }, [urlId])

    const getAutoBills = (id) => {
        const json = {
            page: 1,
            limit: 10,
            search: {
                _id: id
            }
        }
        HitApi(json, searchBill).then((res) => {
            console.log("res---", res);
            if (res?.statusCode === 200 && res?.data?.docs?.[0]) {
                setData(res.data.docs[0]);
            }
        }).catch((error) => {
            console.error("Error fetching bill:", error);
        })
    }
    return (
        <div>
            <AutoBillingPage editMode={data} />
        </div>
    )
}

export default EditStafffBill